import type { AnyFormState } from "@tanstack/react-form";

import type { ButtonProps } from "@/components/ui/button";
import { Button } from "@/components/ui/button";
import type { AnyReactFormApi } from "@/types/form";

type FormBooleanStates = Pick<
  AnyFormState,
  | "canSubmit"
  | "isDirty"
  /**
   * isBlurred is not included is tanstack/react-form but in the docs
   * https://tanstack.com/form/latest/docs/reference/type-aliases/formstate#errormap
   */
  // | "isBlurred"
  | "isFieldsValid"
  | "isFieldsValidating"
  | "isFormValid"
  | "isFormValidating"
  | "isPristine"
  | "isSubmitted"
  | "isSubmitting"
  | "isTouched"
  | "isValid"
  | "isValidating"
>;

type SubscribeButtonProps = {
  Subscribe: AnyReactFormApi["Subscribe"];
  disabledFormStateValues?: Partial<FormBooleanStates>;
} & ButtonProps;

const SubscribeButton = ({
  Subscribe,
  disabledFormStateValues = {
    isSubmitting: true,
    isValid: false,
    isPristine: true,
  },
  ...props
}: SubscribeButtonProps) => {
  return (
    <Subscribe>
      {(formState) => (
        <Button
          {...props}
          disabled={
            Object.entries(disabledFormStateValues).some(
              ([state, value]) =>
                // assertion needed because of Array.some weird typings
                formState?.[state as keyof typeof formState] === value
            ) || props.disabled
          }
        />
      )}
    </Subscribe>
  );
};

export default SubscribeButton;
